import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    HostBinding,
    inject,
    input,
    model
} from '@angular/core';
import {
    ControlValueAccessor,
    Validator,
    FormGroupDirective,
    AbstractControl,
    ValidationErrors,
    ControlContainer,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule
} from '@angular/forms';
import { Store } from '@ngxs/store';
import { ZSelectComponent } from '@shared/components/form-components/z-select/z-select.component';

@Component({
    selector: 'z-dcl-provided-service-category-selector',
    imports: [ZSelectComponent, FormsModule, ReactiveFormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(
                () => ZDclProvidedServiceCategorySelectorComponent
            ),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZDclProvidedServiceCategorySelectorComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective //FormGroupDirective,
        }
    ],
    templateUrl: './z-dcl-provided-service-category-selector.component.html',
    styleUrl: './z-dcl-provided-service-category-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZDclProvidedServiceCategorySelectorComponent
    implements ControlValueAccessor, Validator
{
    @HostBinding('class') class?: string = 'flex grow';
    // @HostBinding('style') style?: string = 'flex-basis: 350px';

    protected rootFormGroup = inject(FormGroupDirective);

    label = input<string | undefined>('Κατηγορία Παρεχόμενων Υπηρεσιών');
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('_id');
    options = model<IProvidedServiceCategoryOption[] | undefined>(undefined);
    placeholder = input<string | undefined>(undefined);
    inputStyle = input<
        | {
              [klass: string]: any;
          }
        | null
        | undefined
    >(undefined);

    store = inject(Store);

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled: boolean = false;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        // const  kk: InvoiceType;
        // kk.Payments?.[0]?.Type

        // https://aade.gr/sites/default/files/2024-12/myDATA%20API%20Documentation%20v1%20.0.10_official_erp.pdf
        this.options.set(
            [
                {
                    _id: 1,
                    Type: '1',
                    Title: 'Εργασία με χρήση ανταλλακτικών',
                    Garage: true,
                    Parking: false,
                    Rental: false
                } as IProvidedServiceCategoryOption,
                {
                    _id: 2,
                    Type: '2',
                    Title: 'Εργασία με χρήση ανταλλακτικών πελάτη',
                    Garage: true,
                    Parking: false,
                    Rental: false
                } as IProvidedServiceCategoryOption,
                {
                    _id: 3,
                    Type: '3',
                    Title: 'Εργασία χωρίς χρήση ανταλλακτικών',
                    Garage: true,
                    Parking: false,
                    Rental: false
                } as IProvidedServiceCategoryOption,
                {
                    _id: 4, // nonIssueInvoice
                    Type: '4',
                    Title: 'Δωρεάν υπηρεσία',
                    Garage: true,
                    Parking: true,
                    Rental: true
                } as IProvidedServiceCategoryOption,

                {
                    _id: 6, // nonIssueInvoice
                    Type: '6',
                    Title: 'Αποζημίωση Παροχής Εγγύησης',
                    Garage: true,
                    Parking: false,
                    Rental: false
                } as IProvidedServiceCategoryOption,
                {
                    _id: 7,
                    Type: '7',
                    Title: 'Υπηρεσία Βάσει Τιμοκαταλόγου',
                    Garage: false,
                    Parking: true,
                    Rental: false
                } as IProvidedServiceCategoryOption,
                {
                    _id: 8,
                    Type: '8',
                    Title: 'Υπηρεσία Κατόπιν Συμφωνίας',
                    Garage: false,
                    Parking: true,
                    Rental: false
                } as IProvidedServiceCategoryOption,
                {
                    _id: 9, // nonIssueInvoice
                    Type: '9',
                    Title: 'Ιδιόχρηση',
                    Garage: true,
                    Parking: true,
                    Rental: false
                } as IProvidedServiceCategoryOption
                // {
                //     _id: 5,
                //     Type: '5',
                //     Title: 'Λοιπά',
                //     Garage: true,
                //     Parking: true,
                //     Rental: true
                // } as IProvidedServiceCategoryOption
            ].filter((item) => item.Garage == true)
        );
    }
}

export class IProvidedServiceCategoryOption {
    _id?: number;
    Type?: string;
    Title?: string;
    Garage?: boolean;
    Parking?: boolean;
    Rental?: boolean;
}
